import { $, insertHTML } from "./dom.js";
import { visibilityPostFormData, iconArrowLeft16, iconX16, iconGroup24, iconSearch48, groupActiveSvg, visibilityPostFormData as __visibilityPostFormData, pIcon } from "./templates.js";

// Public UI helpers extracted from legacy buddypress.js
// They preserve original behavior (use jQuery/global fallbacks) but
// are now exported as ES module functions for easier testing and reuse.

export function toggleActivityPostFormPopup(type) {
    const activityPostFormDom = document.getElementById("bp-nouveau-activity-form");
    if (!activityPostFormDom) return;

    if (type === "open") {
        const headingEl = activityPostFormDom.querySelector(".activity-post-form-header h4");
        const livePrevEl = activityPostFormDom.querySelector(".whats-new-live-preview");

        if (headingEl) headingEl.textContent = "Create post";
        if (livePrevEl) livePrevEl.remove();
        activityPostFormDom.classList.add("activity-post-form-popup");
        const previewar = activityPostFormDom.querySelector(".whats-new-previewer");
        if (!previewar) return;
        previewar.classList.remove("previewer-toggle");
        activityPostFormDom.style.display = "block";
        
        document.querySelector("#whats-new-attachments").style.display = 'none';
        
        const whatsNewContent = document.querySelector("#whats-new-content");
        if(whatsNewContent) {
            whatsNewContent.style.display = 'block';
        }
        const whatsNewAttachments = document.querySelector("#whats-new-attachments");
        if(whatsNewAttachments) {
            whatsNewAttachments.style.display = 'block';
        }

        const whatsNewHeaderMediaSection = document.querySelector(".whats-new-header-media-section");
        if(whatsNewHeaderMediaSection) {
            whatsNewHeaderMediaSection.style.display = 'none';
        }
        
        const advancedThBpActivityForm = document.querySelector(".advanced-th-bp-activity-form");
        if(advancedThBpActivityForm) {
            advancedThBpActivityForm.focus();
        }

        const whatsNewIntroHeader = document.querySelector(".whats-new-intro-header");
        if(whatsNewIntroHeader) {
            whatsNewIntroHeader.style.fontSize = "21px";
            whatsNewIntroHeader.style.fontWeight = "400";
            whatsNewIntroHeader.style.display = 'none';
        }
    }

    if (type === "close") {
        activityPostFormDom.classList.remove("activity-post-form-popup");
        const previewar = activityPostFormDom.querySelector(".whats-new-previewer");
        if (!previewar) return;
        activityPostFormDom.style.display = "none";
        previewar.classList.remove("previewer-toggle");
        const submitBtn = activityPostFormDom.querySelector("#aw-whats-new-submit");
        if (submitBtn) {
            submitBtn.value = "Post";
            submitBtn.setAttribute("disabled", "disabled");
        }
        if (typeof window.resetGroupAndViType === 'function') {
            window.resetGroupAndViType(activityPostFormDom);
        }
        const postBox = activityPostFormDom.querySelector("#th-bp-whats-new");
        if (postBox) postBox.innerText = "";

        // preserve legacy globals used by other scripts
        try { window.mf_activity_edite_is_delete_activity = false; } catch(e){}
        try { window.mf_activity_id_of_current_editeing_activity = false; } catch(e){}
        try { window.mf_activity_current_editing_activity_dom = false; } catch(e){}
    }
}

export function markupPostFormGroups(groups) {
  return `${groups
    .map(
      (cur) => `
     <div class="ac-vi-group-item" data-id="${cur.id}">
      <!-- <img src="" alt="" /> -->      
      <p class="ac-vi-group-label">${cur.dom.label}</p>
      <span class="ac-vi-group-select"></span>
     </div>
    `
    )
    .join(" ")}`;
}

export function activityGroupMarkup(groups) {
  const markup = `
  <div class="ac-group-main">
     <div class="ac-group-header">
    <p>Select a group</p>
    <span class="close-popup">${iconX16}</span>
     </div>
     <div class="ac-group-search">
    <input class="ac-vi-group-search-input" 
    type="text" placeholder="Search groups" />
    ${iconSearch48}
     </div>
     <div class="ac-group-lists">
     ${markupPostFormGroups(groups)}
     </div>
     <div class="ac-group-footer">
      <span class="ac-group-back">Back</span>
      <span class="ac-group-save">Save</span>
     </div>
  </div>
  `;

  return markup;
}

export function renderDefaultVisibility(text, formDom) {
    const nameDom = $(".what-is-new-avatar-text", formDom);
        const markup = `<div id="visibility-handler">
       ${pIcon}
            <span>${text}</span>
          </div>`;
    insertHTML(nameDom, markup, 'beforeend');
}

export function getgroups(formDom) {
    const groupDom = formDom.querySelectorAll("#whats-new-post-in option");
    if (!groupDom.length) return [];

    return Array.from(groupDom).map((cur, i) => ({
        dom: cur,
        index: i,
        id: cur.value,
        groups: groupDom,
    }));
}

export function getVisibility(formDom) {
    const visibilityTypesDom = formDom.querySelectorAll("#mf-activity-accessibility option");
    if (!visibilityTypesDom.length) return [];
    return Array.from(visibilityTypesDom).map((cur, i) => ({
        dom: cur,
        index: i,
        id: Math.round(Math.random() * 50),
        visibilitys: visibilityTypesDom,
    }));
}

/** Returns the activity visibility markup.
 * @returns {string} The activity visibility markup.
 */
export function activityVisibilityMarkup() {
    const markup = `
  <div class="ac-vi-form-pop-main">
       <div class="ac-vi-form-content">
         <div class="ac-vi-form-head">
           <p class="ac-vi-form-header-text">
       <span class="visibility-back">${iconArrowLeft16}</span>
       Who can see your post?</p>
      <span class="close-popup">${iconX16}</span>
         </div>
         <div class="ac-vi-form-options">
        <div class="ac-vi-form-option-public" data-type="public">
          <span class="ac-vi-form-option-svg-bg"> ${visibilityPostFormData.find((cur) => cur.vi == 'public').svg} </span>
        <div>
              <p class="ac-vi-form-option-title">Public</p>
              <span class="ac-vi-form-option-des">Visible to anyone, on or off this site</span>
            </div>
            <span class="ac-vi-form-option-selected-fill"></span>
           </div>
           <div class="ac-vi-form-option-friends" data-type="friends">
            <span class="ac-vi-form-option-svg-bg"> ${visibilityPostFormData.find((cur) => cur.vi == 'friends').svg} </span>
            <div>
               <p class="ac-vi-form-option-title">Friends</p>
               <span class="ac-vi-form-option-des">Visible only to your connections</span>
            </div>
            <span class="ac-vi-form-option-selected-fill"></span>
           </div>
           <div class="ac-vi-form-option-onlyme" data-type="onlyme">
            <span class="ac-vi-form-option-svg-bg"> ${visibilityPostFormData.find((cur) => cur.vi == 'onlyme').svg} </span>
            <div>
              <p class="ac-vi-form-option-title">Only me</p>
               <span class="ac-vi-form-option-des">Visible only to you</span>
            </div>
            <span class="ac-vi-form-option-selected-fill"></span>
           </div>
           <div class="ac-vi-form-option-group">
            <span class="ac-vi-form-option-svg-bg"> ${iconGroup24} </span>
      <div>
        <p class="ac-vi-form-option-title">Group</p>
        <span class="ac-vi-form-option-des">Visible to selected group</span>
      </div>
      <span class="ac-vi-form-option-selected-fill"></span>
     </div>
     </div>
   </div>
  </div>
  `;

    return markup;
}

/**
 * Sets the group visibility markup in the post form.
 * @param {HTMLElement} formDom The form DOM element.
 * @param {string} label The group label.
 */
export function setGroupViMarkup(formDom, label) {
    const con = formDom.querySelector("#visibility-handler");
    con.innerHTML = '<div class="group-ac-vi-active">' + groupActiveSvg + '<span>' + label + '</span></div>';
}

/**
 * Sets the hidden input value for activity visibility.
 * @param {HTMLElement} formDom The form DOM element.
 * @param {string} visibilityType The visibility type (e.g., 'public', 'friends').
 */
export function setPostVisibility(formDom, visibilityType) {
    const hiddenVisisbilityEl = formDom.querySelector("#mf-activity-accessibility");
    if (!hiddenVisisbilityEl) {
        console.error("no activity visibility el found");
        return;
    }
    hiddenVisisbilityEl.value = visibilityType;
}

/**
 * Sets the visibility markup in the post form.
 * @param {HTMLElement} formDom The form DOM element.
 * @param {string} viType The visibility type.
 */
export function setViMarkup(formDom, viType) {
    const con = formDom.querySelector("#visibility-handler");
    if (!con) return;
    const markup = `
    ${__visibilityPostFormData.find((cur) => cur.vi == viType).svg}
    <span>${viType}</span>`;
    con.innerHTML = markup;
}
